import { fetchClient, HttpClient } from '@cld/session-service';
import { API_BASE_URL, getSerializedUser, RawUser, User } from '@cld/application-wrapper-common';

export const createFetchUserInfo = (httpClient: HttpClient<RawUser>) => (): Promise<User> => {
  return httpClient(`${API_BASE_URL}/user`).then(getSerializedUser);
};

// istanbul ignore next
export const fetchUserInfo = createFetchUserInfo(fetchClient);
